// extracted by mini-css-extract-plugin
module.exports = {"card":"styles-module--card--2sYX8"};